<div class="modal-header main-modal-header">
    <button type="button" class="close" aria-hidden="true" (click)="cancel()">&times;</button>
    <h4 class="modal-title wrap-text-in" *ngIf="!isModifyPlan">Choose Plan '{{selectedPlanName}}' </h4>
    <h4 class="modal-title wrap-text-in" *ngIf="isModifyPlan">Modify Plan '{{selectedPlanName}}' </h4>
</div>

<div class="modal-body">
    <div class="main-box" style="padding-bottom: 15px">
        <div class="row" style="margin-top:20px">
            <div class="col-xs-12">
                <div class="col-xs-12 modify-non-trial-plan">
                    <div class="col-xs-12">
                        <div class="col-xs-4" *ngIf="!isVendorPlan">
                            <label for="planType" class="control-label">Plan Type: </label>
                            <select class="form-control" name="planType" id="plantype"
                                [(ngModel)]="selectedPlan.planHeaderDto.planType" *ngIf="!isTrialPlan"
                                (ngModelChange)="onPlanTypeChange()" required>
                                <option *ngFor="let planType of planTypeList" [value]="planType">{{planType}}</option>
                            </select>
                            <input type="text" name="planType" id="planType"
                                [(ngModel)]="selectedPlan.planHeaderDto.planType" *ngIf="isTrialPlan"
                                class="form-control" disabled>
                        </div>
                    </div>
                    <div class="col-xs-12" style="margin-top:10px">
                        <div class="col-xs-4">
                            <div class="form-group">
                                <label for="timezoneName" class="control-label">
                                    Time Zone:
                                </label>
                                <div style="display: block">
                                    <select class="form-control" id="timezoneName"
                                        [(ngModel)]="selectedPlan.planHeaderDto.timeZoneName">
                                        <optgroup *ngFor="let groupName of groupedTimezones | keyvalue" [label]="groupName.key">
                                            <option *ngFor="let zone of groupName.value" [value]="zone.name">{{zone.displayText}}</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-4">
                            <label class="control-label">Effective Start Date: </label>
                            <div class="col-xs-12">
                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <input type="text" name="effectiveStartDate" id="effectiveStartDate"
                                        class="form-control"
                                        [(ngModel)]="selectedPlan.planHeaderDto.planStartDateDisplay"
                                        [disabled]="isModifyPlan">
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-4">
                            <div class="col-xs-12">
                                <label class="control-label">Effective End Date: </label>
                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <input type="text" name="effectiveEndDate" id="effectiveEndDate" class="form-control"
                                        [(ngModel)]="selectedPlan.planHeaderDto.planEndDateDisplay">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12" style="margin-top:20px"
                        *ngIf="!isTrialPlan && !isVendorPlan">
                        <div class="col-xs-4">
                            <div class="col-xs-8">
                                <label for="assessmentUsed" class="control-label">Assessments Used: </label>
                            </div>
                            <div class="col-xs-4">
                                <span>{{selectedPlan.planDetailDto.taUsed}}</span>
                            </div>
                        </div>
                        <div class="col-xs-4">
                            <div class="col-xs-8">
                                <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes Pulled:
                                </label>
                            </div>
                            <div class="col-xs-4">
                                <span>{{selectedPlan.planDetailDto.jbiUsed}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 modify-trial-plan" *ngIf="isTrialPlan">

                        <div class="col-xs-12" style="margin-top:20px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentAllocated" class="control-label">Assessments Allocated: </label>
                                </div>
                                <div class="col-xs-6">
                                    <span>{{selectedPlan.planDetailDto.taAllocated}}</span>
                                    <span *ngIf="selectedPlan.planDetailDto.taAdded !== 0">
                                        (+ {{selectedPlan.planDetailDto.taAdded}} =
                                        {{selectedPlan.planDetailDto.taAllocated + selectedPlan.planDetailDto.taAdded}})</span>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentUsed" class="control-label">Assessments Used: </label>
                                </div>
                                <div class="col-xs-6">
                                    <span>{{selectedPlan.planDetailDto.taUsed}}</span>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentAdd" class="control-label">Add Assessments: </label>
                                </div>
                                <div class="col-xs-6">
                                    <input type="number" [(ngModel)]="selectedPlan.planDetailDto.taAdded"
                                        class="form-control" name="assessmentAdd" id="assessmentAdd"
                                        style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="margin-top:10px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesAllocated" class="control-label">Job Boards Resumes
                                        Allocated:
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <span>{{selectedPlan.planDetailDto.jbiAllocated}}</span>
                                    <span *ngIf="selectedPlan.planDetailDto.jbiAdded !== 0">
                                        (+ {{selectedPlan.planDetailDto.jbiAdded}} =
                                        {{selectedPlan.planDetailDto.jbiAllocated + selectedPlan.planDetailDto.jbiAdded}})</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes Pulled:
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <span>{{selectedPlan.planDetailDto.jbiUsed}}</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesAdd" class="control-label">Add Job Boards Resumes: </label>
                                </div>
                                <div class="col-xs-6">
                                    <input type="number" [(ngModel)]="selectedPlan.planDetailDto.jbiAdded"
                                        class="form-control" name="jobBoardsResumesAdd" id="jobBoardsResumesAdd"
                                        style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xs-12 text-right">
        <div class="mr-3 pr-4 pb-4">
            <button class="btn btn-danger mr-2" (click)="cancel()">
                <span>Cancel</span>
            </button>
            <button type="button" class="btn btn-success" (click)="savePlan()">
                <span *ngIf="!isModifyPlan">Choose Plan</span>
                <span *ngIf="isModifyPlan">Modify Plan</span>
            </button>
        </div>
    </div>
</div>
